var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiteracyEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lit-event",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .le-cls-1 {\n        stroke: #14163d;\n        stroke-width: 6px;\n      }\n\n      .le-cls-1, .le-cls-2, .le-cls-3 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .le-cls-1, .le-cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .le-cls-2 {\n        stroke-linejoin: round;\n        stroke-width: 5px;\n      }\n\n      .le-cls-2, .le-cls-3 {\n        stroke: #fff;\n      }\n\n      .le-cls-3 {\n        stroke-width: 4px;\n      }\n\n      .le-cls-4 {\n        fill: #14163d;\n      }\n\n      .le-cls-4, .le-cls-5 {\n        stroke-width: 0px;\n      }\n\n      .le-cls-5 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lit_Event_Icon",
    "data-name": "Lit Event Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "le-cls-4",
    cx: 130,
    cy: 130,
    r: 130
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "le-cls-5",
    d: "m54.17,90.37v80.49s48.56.37,73.58,19.39v-80.49c-25.02-19.01-73.58-19.39-73.58-19.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-5",
    d: "m205.83,90.37v80.49s-48.56.37-73.58,19.39v-80.49c25.02-19.01,73.58-19.39,73.58-19.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-2",
    d: "m214.88,97.52s0,82.07,0,82.07h-6.35s-50.29.39-76.2,20.07h-4.66c-25.91-19.69-76.2-20.07-76.2-20.07h-6.35s0-82.07,0-82.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m194.23,109.68c-12.54.95-34.73,3.77-52.29,12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m194.23,123.87c-12.54.95-34.73,3.77-52.29,12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m194.23,138.06c-12.54.95-34.73,3.77-52.29,12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m194.23,152.26c-12.54.95-34.73,3.77-52.29,12.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m65.77,109.68c12.54.95,34.73,3.77,52.29,12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m65.77,123.87c12.54.95,34.73,3.77,52.29,12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m65.77,138.06c12.54.95,34.73,3.77,52.29,12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "le-cls-1",
    d: "m65.77,152.26c12.54.95,34.73,3.77,52.29,12.06"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "le-cls-3",
    x1: 130,
    y1: 70.04,
    x2: 130,
    y2: 41.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "le-cls-3",
    x1: 158.85,
    y1: 77.44,
    x2: 172.52,
    y2: 52.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "le-cls-3",
    x1: 101.15,
    y1: 77.44,
    x2: 87.48,
    y2: 52.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteracyEvent);
export default __webpack_public_path__ + "static/media/LiteracyEvent.191f1a8a46202b2a5dc41ae7d614d3de.svg";
export { ForwardRef as ReactComponent };